import React, { Component } from 'react';
import { observer } from 'mobx-react';
import MovePanelButton from './MovePanelButton';

@observer
class PanelOptions extends Component {
  handleMovePanel = (toSectionId) => {
    const { panel, onSectionChange } = this.props;
    onSectionChange(panel, toSectionId);
  };

  render() {
    const { panel } = this.props;

    const hasSections = (panel.collection.get() || []).some((p) => p.get('type') === 'section');
    if (!hasSections) {
      return null;
    }

    return (
      <>
        <MovePanelButton panel={panel} text="Move Panel to Section" onMovePanel={this.handleMovePanel} />
      </>
    );
  }
}

export default PanelOptions;
